<template>
  <div class="card-clientes-desenvolvimento">
    <g-card :expansivel="false" :temCabecalho="false">
      <div class="cabecalho-formulario">
        <div class="titulo-formulario titulo-cliente-desenvolvimento"> Cadastrar Clientes em Desenvolvimento </div>
      </div>
      <g-form>
        <div class="conteudo-clientes-desenvolvimento espacamento-filtros">
          <div class="titulo-grupo-formulario"> Dados Cadastrais </div>
          <div class="grupo-dados-cadastrais">
            <div class="dados-unidade">
              <div class="titulo-conteudo-filtros"> Unidade <strong class="asterisco-obrigatorio">*</strong></div>
              <PDropDown
              placeholder="Selecione"
              :filter="true"
              :options="EmpresaArray"
              optionLabel="nome"
              optionValue="id"
              v-model="objCliente.EmpresaSelecionada"
              >
              </PDropDown>
            </div>

            <div class="dados-cnpj">
              <div class="titulo-conteudo-filtros"> CNPJ <strong class="asterisco-obrigatorio">*</strong></div>
              
              <div class="checkbox-filtros-cnpj">
              <div style="display: flex; gap: 1rem; align-items: center;">
                  <PInputText
                  v-if="!objCliente.checkboxExt"
                  class="input-padrao"
                  placeholder="Insira o CNPJ do cliente"
                  v-mask="'##.###.###/####-##'"
                  :disabled="desabilitado"
                  v-model="objCliente.cnpj"
                  v-on:blur = "verificaCPNJExistenteOuNao"

                  >
                  </PInputText>

                  <PInputText
                  v-else
                  class="input-padrao"
                  placeholder="Insira o CNPJ do cliente"
                  v-mask="'###.###.###/####-##'"
                  :disabled="desabilitado"
                  v-model="objCliente.cnpj"
                  v-on:blur = "verificaCPNJExistenteOuNao"

                  >
                  </PInputText>


                  <g-button
                class="buscar-button"
                largura="32px"
                icone="icone_lupa.svg"
                negritoTexto
                tamanhoIcone="13px"
                tamanhoTexto="12px"
                altura="32px"
                :somenteIcone="true"
                :sombreado="false"
                @click="verificaCPNJ"
                v-tooltip="'Busca informações do cliente no SINTEGRA'"
                >
                </g-button>
                </div>
              </div>
              <div class="input-checkbox">
                <PCheckBox
                class="checkbox-ext"
                id="ext"
                :binary="true"
                @click="cnpjExterior"
                @change="cidades_exterior"
                v-model="objCliente.checkboxExt"
                ></PCheckBox>
                <label class="label-checkbox" for="ext"> Exterior </label>
              </div>
            </div>

            <div class="dados-razao-social">
              <div class="titulo-conteudo-filtros"> Razão Social <strong class="asterisco-obrigatorio">*</strong></div>
              <PInputText
              class="input-padrao"
              placeholder="Insira a Razão Social do cliente"
              maxlength="50"
              v-model="objCliente.razaoSocial"
              ></PInputText>
            </div>

            <div class="dados-nome-fantasia">
              <div class="titulo-conteudo-filtros"> Nome Fantasia <strong class="asterisco-obrigatorio">*</strong></div>
              <PInputText
              class="input-padrao"
              placeholder="Insira o Nome Fantasia"
              maxlength="20"
              v-model="objCliente.nomeFantasia"
              ></PInputText>
            </div>

            <div class="dados-cep">
              <div class="titulo-conteudo-filtros"> CEP </div>
              <div style="display: flex; gap: 1rem; align-items: center;">

                <PInputMask
                class="input"
                placeholder="00000-000"
                mask="99999-999"
                :disabled="this.desabilitarcep"
                v-model="cep"
                ></PInputMask>

                <!-- <g-button
                  class="buscar-button"
                  largura="32px"
                  icone="icone_lupa.svg"
                  negritoTexto
                  tamanhoIcone="13px"
                  tamanhoTexto="12px"
                  altura="32px"
                  :somenteIcone="true"
                  :sombreado="false"
                  @click="getCEP"
                  v-tooltip="'Busca cidade e estado no VIACEP'"
                  >
                  </g-button> -->
              </div>
            </div>

            <div class="dados-estado">
              <div class="titulo-conteudo-filtros"> Estado <strong class="asterisco-obrigatorio">*</strong></div>
              <PDropDown
              :filter="true"
              placeholder="Selecione"
              @change="buscarcidade"
              :options="EstadoArray"
              optionLabel="siglaEstado"
              optionValue="id"
              :disabled="DesativaEstado"
              v-model="objCliente.EstadoSelecionado"
              >
                <template v-if="EdicaoBack" #value>
                  {{ ufValue}}
                </template>
              </PDropDown>
            </div>

            <div class="dados-cidade">
              <div class="titulo-conteudo-filtros"> Cidade <strong class="asterisco-obrigatorio">*</strong></div>
              <PDropDown
              placeholder="Selecione"
              :filter="true"
              @filter="buscarCidadeSemEstado($event.value)"
              @change="setCidade"
              :options="CidadeArray"
              optionLabel="nomeCidade"
              optionValue="id"
              :disabled="DesativaCidade"
              v-model="objCliente.CidadeSelecionada"
              >
                <template v-if="EdicaoBack" #value>
                  {{ cidadeValue }}
                </template>
              </PDropDown>
            </div>

            <div class="dados-segmento">
              <div class="titulo-conteudo-filtros"> Segmento <strong class="asterisco-obrigatorio">*</strong></div>
              <PDropDown
              :filter="true"
              placeholder="Selecione"
              :options="SegmentoArray"
              optionLabel="descricao"
              optionValue="clienteTipoId"
              v-model="objCliente.ClienteTipoId"
              ></PDropDown>
            </div>

            <div class="dados-perfil-material">
              <div class="titulo-conteudo-filtros"> Perfil Material <strong class="asterisco-obrigatorio">*</strong></div>
              <PDropDown
              placeholder="Selecione"
              :options="PerfilMaterialArray"
              optionLabel="text"
              optionValue="enum"
              v-model="objCliente.PerfilMaterialSelecionado"
              ></PDropDown>
            </div>

            <div class="dados-potencial-cliente">
              <div class="titulo-conteudo-filtros"> Potencial do Cliente <strong class="asterisco-obrigatorio">*</strong></div>
              <PDropDown
              placeholder="Selecione"
              :options="PotencialArray"
              optionLabel="text"
              optionValue="enum"
              v-model="objCliente.PotencialSelecionado"
              >
              </PDropDown>
            </div>

            <div class="dados-codigo-cliente">
              <div class="titulo-conteudo-filtros"> Código do Cliente </div>
              <PInputText
              class="input-padrao"
              placeholder="Código do cliente"
              type="int"
              maxlength="5"
              disabled
              v-model="codigo"
              ></PInputText>
            </div>

            <div class="dados-curva-cliente">
              <div class="titulo-conteudo-filtros"> CV </div>
              <PInputText
              placeholder="CV"
              disabled
              v-model="cv"
              ></PInputText>
            </div>

            <div class="dados-telefone-celular">
              <div class="titulo-conteudo-filtros"> Telefone/Celular <strong class="asterisco-obrigatorio">*</strong></div>
              <!-- {{this.objCliente.telefone }} -->
              <!-- <InputClienteTelefone :clienteId="$store.state.cliente.id" v-model="objCliente.telefone" @invalido="telefoneCelularInvalido = $event"/> -->
              <PInputText
              type="text"
              v-model="objCliente.telefone"
              @keypress="camponumero"
              maxlength="12"
              placeholder="(99) 99999-9999"
              autoFocus
            />
            </div>
            
            <div class="dados-suframa-inscricao" v-if="this.objCliente.cidadenome === 'Manaus' || this.objCliente.cidadenome === 'MANAUS' || this.objCliente.cidadeValue === 'Manaus'|| this.objCliente.cidadeValue === 'MANAUS'">
              <div class="dados-suframa">
                <div class="titulo-conteudo-filtros"> Possui suframa? <strong class="asterisco-obrigatorio">*</strong></div>
                <div class="buttons-suframa checkbox-filtros">
                  <div class="input-checkbox">
                    <PRadioButton class="espaçamento" name="suframa" value="sim" v-model="suframaSimNao"></PRadioButton>
                    <div class="label-checkbox"> Sim </div>
                  </div>
                  <div class="input-checkbox">
                    <PRadioButton class="espaçamento" name="suframa" value="nao" v-model="suframaSimNao"></PRadioButton>
                    <div class="label-checkbox"> Não </div>
                  </div>
                </div>
              </div>

              <div class="dados-inscricao-suframa" v-if="this.objCliente.cidadenome === 'Manaus' || this.objCliente.cidadenome === 'MANAUS' || this.objCliente.cidadeValue === 'Manaus'|| this.objCliente.cidadeValue === 'MANAUS'">
                <div class="titulo-conteudo-filtros"> Inscrição Suframa <strong class="asterisco-obrigatorio">*</strong></div>
                <PInputNumber
                name="inscricaoSuframa"
                v-model="objCliente.NumeroSuframa"
                ></PInputNumber>
              </div>
            </div>

            <div class="dados-incentivos">
              <div class="parametros-titulo titulo-conteudo-filtros"> Possui incentivo fiscal - Diferimento? </div>
              <div class="checkbox-filtros">
                <div class="incentivo-icms input-checkbox">
                  <PCheckBox
                  id="incentivo-icms"
                  class="checkbox-incentivo-icms"
                  :binary="true"
                  :customUpload="true"
                  @click="uploadArquivoICMS"
                  v-model="objCliente.icms"
                  ></PCheckBox>
                  <label class="incentivoIcms label-checkbox" for="incentivo-icms" > ICMS </label>
                </div>

                <div class="incentivo-pis input-checkbox">
                  <PCheckBox
                  id="incentivo-pis"
                  class="checkbox-incentivo-pis"
                  :binary="true"
                  @click="uploadArquivoPIS"
                  v-model="objCliente.pis"
                  ></PCheckBox>
                  <label class="incentivoPis label-checkbox" for="incentivo-pis" > PIS / COFINS </label>
                </div>

                <div class="incentivo-ipi input-checkbox">
                  <PCheckBox
                  id="incentivo-ipi"
                  class="checkbox-incentivo-ipi"
                  :binary="true"
                  @click="uploadArquivoIPI"
                  v-model="objCliente.ipi"
                  ></PCheckBox>
                  <label class="incentivoIpi label-checkbox" for="incentivo-ipi" > IPI </label>
                </div>
              </div>
            </div>

            <div class="buttons-arquivos">
              <g-button
              v-if="objCliente.icms == true"
              altura="35px"
              largura="200px"
              negritoTexto
              tamanhoTexto="15px"
              @click="AbrirpopupICMS"
              >
                Adicionar Arq. ICMS
              </g-button>

              <PDialog :closable="true" v-model:visible="popupICMS" :modal="true">
                <template #header>
                  <div class="titulo-detalhes-cabecalho"> Adicionar Arquivo ICMS </div>
                </template>

                <g-file-upload :uploadedFiles="ICMSArray" v-on:edit="ImageEdit" :arquivoMultiplo="true" :imagemPdf="true" v-on:upload="uploadICMS"></g-file-upload>
                <div class="button-fechar-popup">
                  <g-button
                  tipo="cinza"
                  altura="35px"
                  largura="15em"
                  negritoTexto
                  tamanhoTexto="15px"
                  @click="Fecharicms"
                  >
                    FECHAR
                  </g-button>
                </div>
              </PDialog>
              
              <div id="popupImage">
                <PDialog v-model:visible="popupEditImage" class="popup-dev" style="width: 53vw; border-radius: 5%;">
                  <div class="infoBasicas-imagemProduto">
                    <div v-if="imageArray.length === 0" class="img-info-mobile"> NENHUMA IMAGEM DISPONÍVEL! </div>
                    <template v-else>
                      <div class="image-container">
                        <div v-for="(image, id) in imageArray" :key="id" class="image-wrapper">
                            <PImage
                              v-on:error="erro($event)"
                              :src="'data:image/png;base64,' + image.base64Arquivo"
                              :imageStyle="styleImg"
                              :preview="true"
                            />
                            <PButton style="width: 22em;" class="image-button" icon="pi pi-trash" @click="deleteImage(image.id)" text />
                        </div>
                      </div>  
                    </template>
                  </div>
                </PDialog>
              </div>

              <g-button
              v-if="objCliente.pis == true"
              altura="35px"
              largura="200px"
              negritoTexto
              tamanhoTexto="15px"
              @click="AbrirpopupPIS"
              >
                Adicionar Arq. PIS/COFINS
              </g-button>

              <PDialog :closable="true" v-model:visible="popupPIS" :modal="true">
                <template #header>
                  <div class="titulo-detalhes-cabecalho"> Adicionar Arquivo PIS/COFINS </div>
                </template>

                <g-file-upload  v-on:edit="ImageEdit" :arquivoMultiplo="true" :imagemPdf="true" v-on:upload="uploadPIS"></g-file-upload>

                <div class="button-fechar-popup">
                  <g-button
                  tipo="cinza"
                  altura="35px"
                  largura="15em"
                  negritoTexto
                  tamanhoTexto="15px"
                  @click="fecharpis"
                  >
                    FECHAR
                  </g-button>
                </div>
              </PDialog>

              <g-button
              v-if="objCliente.ipi == true"
              altura="35px"
              largura="200px"
              negritoTexto
              tamanhoTexto="15px"
              @click="AbrirpopupIPI"
              >
                Adicionar Arq. IPI
              </g-button>

              <PDialog :closable="true" v-model:visible="popupIPI" :modal="true">
                <template #header>
                  <div class="titulo-detalhes-cabecalho"> Adicionar Arquivo IPI </div>
                </template>

                <g-file-upload  v-on:edit="ImageEdit" :arquivoMultiplo="true" :imagemPdf="true" v-on:upload="uploadIPI"></g-file-upload>

                <div class="button-fechar-popup">
                  <g-button
                  tipo="cinza"
                  altura="35px"
                  largura="15em"
                  negritoTexto
                  tamanhoTexto="15px"
                  @click="fecharIPI"
                  >
                    FECHAR
                  </g-button>
                </div>
              </PDialog>
            </div>
          </div>
        </div>

        <div class="grid-cliente-contato">
          <g-data-table class="datatabletelefone"
          Titulo="Contatos"
          TextoVazio="Nenhum contato cadastrado"
          :colunas="colunasTelefone"
          :NumeroLinhas="6"
          :Filtros="Filtro"
          :valores="informacaotelefone"
          :Adicionavel="true"
          :Editavel = "true"
          v-on:acaoAdicionar="popupadicionar"
          v-on:editar="editar"
          v-on:getlinha="getlinha"
          v-on:excluir="excluir"
          >
          </g-data-table>

          <PDialog class="gama-popup" :closable="true" v-model:visible="popuptelefones" :style="{ width: '60%' }" :modal="true">
            <template #header>
              <div class="titulo-formulario"> Adicionar Contato </div>
            </template>

            <div class="grupo-form-contato">
              <div class="popup-tipo-contato">
                <div class="titulo-conteudo-filtros"> Tipo de Contato <strong class="asterisco-obrigatorio">*</strong></div>
                <PDropDown
                placeholder="Selecione"
                :filter="true"
                :options="TipoContatoArray"
                optionLabel="text"
                v-model="TipoContato"
                ></PDropDown>
              </div>

              <div class="popup-nome-contato">
                <div class="titulo-conteudo-filtros"> Nome do Contato <strong class="asterisco-obrigatorio">*</strong></div>
                <PInputText
                placeholder="Insira o nome do contato"
                maxlength="30"
                v-model="nomeContato"
                ></PInputText>
              </div>

              <div class="popup-funcao-contato">
                <div class="titulo-conteudo-filtros"> Função </div>
                <PInputText
                placeholder="Insira a função do contato"
                maxlength="20"
                v-model="nomeFuncao"
                ></PInputText>
              </div>

              <div class="linha1 linha-separacao"></div>

              <div class="popup-site">
                <div class="titulo-conteudo-filtros"> Site </div>
                <PInputText
                placeholder="Insira o site do contato"
                maxlength="40"
                v-model="clienteSite"
                ></PInputText>
              </div>

              <div class="popup-email">
                <div class="titulo-conteudo-filtros"> Email <strong class="asterisco-obrigatorio">*</strong></div>
                <PInputText
                placeholder="Insira o email do contato"
                maxlength="60"
                v-model="email"
                ></PInputText>
              </div>

              <div class="linha2 linha-separacao"></div>

              <div class="popup-telefone">
                <div class="titulo-conteudo-filtros"> Telefone <strong class="asterisco-obrigatorio">*</strong></div>
                <PInputMask
                placeholder="Insira o telefone do contato"
                mask="(99) 9999-9999"
                v-model="numeroTelefone"
                ></PInputMask>
              </div>

              <div class="popup-celular">
                <div class="titulo-conteudo-filtros"> Celular <strong class="asterisco-obrigatorio">*</strong></div>
                <PInputMask
                placeholder="Insira o celular do contato"
                mask="(99) 99999-9999"
                v-model="numeroCelular"
                ></PInputMask>
              </div>

              <div class="popup-telefone-exterior" v-if="objCliente.checkboxExt == true">
                <div class="titulo-conteudo-filtros"> Telefone Exterior </div>
                <PInputMask
                placeholder="Insira o telefone exterior"
                mask="+99 99 9999999999"
                v-model="telefoneExterior"
                ></PInputMask>
              </div>

              <div class="popup-celular-exterior" v-if="objCliente.checkboxExt == true">
                <div class="titulo-conteudo-filtros"> Celular Exterior </div>
                <PInputMask
                placeholder="Insira o celular exterior"
                mask="+99 99 9999999999"
                v-model="celularExterior"
                ></PInputMask>
              </div>
            </div>

            <div class="botoes-popup button-popup">
              <div>
                <g-button
                tipo="cinza"
                negritoTexto
                largura="230px"
                altura="35px"
                @click="cancelartelefone"
                >
                  CANCELAR
                </g-button>
              </div>

              <div>
                <g-button
                v-if="!editando"
                negritoTexto
                largura="230px"
                altura="35px"
                @click="AdicionarNaTabela"
                >
                  ADICIONAR
                </g-button>
              </div>

              <div>
                <g-button
                v-if= "editando === true"
                negritoTexto
                largura="230px"
                altura="35px"
                @click="editarBotao"
                >
                  ATUALIZAR
                </g-button>
              </div>
            </div>
          </PDialog>

          <div class="buttons-next-back">
            <div class="button-next">
              <g-button
              tipo="amarelo"
              negritoTexto
              altura="35px"
              largura="100%"
              @click="gravar"
              :disabled = "desabilitaGravar"
              >
                GRAVAR
              </g-button>
            </div>

            <div class="button-back">
              <g-button
              tipo="cinza"
              altura="35px"
              largura="100%"
              negritoTexto
              v-on:acao="limparpt2"
              >
                LIMPAR
              </g-button>
            </div>
          </div>
        </div>

        <PDialog :showHeader="false" :closable="false" v-model:visible="popup" :modal="true">
          <div class="titulo-popup-finalizado"> Cliente cadastrado com sucesso! </div>
          <div class="botoes-popup">
            <div>
              <g-button
              tipo="cinza"
              negritoTexto
              largura="200px"
              altura="35px"
              @click="consultar"
              >
              CONSULTAR
              </g-button>
            </div>
            <div>
              <g-button
              negritoTexto
              largura="200px"
              altura="35px"
              @click="fecharClienteDesenv"
              >
                FECHAR
              </g-button>
            </div>
          </div>
        </PDialog>

        <!-- POPUP CONFERIR CNPJ BANCO -->
      <cnpj-existente
      :emDesenvolvimento="this.situacaoVindaDoBanco"
      :visivel="popupjaexiste"
      v-on:cancelarcadastrocnpj="cancelarcadastrarcnpj"
      v-on:editarcnpjexistente="editarcnpjexistente">
      </cnpj-existente>

      <PDialog class="cliente-aviso-popup" :showHeader="false" :closable="true" v-model:visible="aparecerAvisoJaExiste" :modal="true">
          <div class="cliente-aviso-container">
            <div class="conteudopopupinicial" v-if="this.codigoGenerico == 0">
              Já existe cliente cadastrado com o CNPJ informado!
            </div>
            <div class="conteudopopupinicial" v-if="this.codigoGenerico == 3">
              Já existe outro cliente cadastrado com o mesmo CNPJ para outro representante!
            </div>
            <div class="conteudopopupinicial" v-if="this.codigoGenerico == 4">
              Já existe outro cliente cadastrado com a mesma base do CNPJ para outro representante!
            </div>
            <g-button tipo="cinza" largura="100%" negritoTexto @click="this.aparecerAvisoJaExiste = false">FECHAR</g-button>
            <!-- <div class="botaonovoeconsultar">
              <div class="botaoconsultar">
              </div>
            </div> -->
          </div>
        </PDialog>

      </g-form>
    </g-card>
  </div>
</template>

<script>

import ClienteEmDesenv from "./ClienteEmDesenv.js";
export default ClienteEmDesenv;
</script>

<style scoped>
.checkbox-filtros-cnpj {
  flex-wrap: wrap;
  flex-direction: row;
  column-gap: 20px;
  row-gap: 2px;
}
:deep(.custom-header) {
  padding-right: 10px;
}
.image-button {
  padding: 8px 16px;
  border: none;
  cursor: pointer;
  width: 22em;
}

.image-container {
  /* Estilos para o container das imagens */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}


.image-wrapper {
  /* Estilos para cada wrapper de imagem e botão */
  margin: 10px;
  text-align: center;
}
.imageStyle {
  width: 400px;
}

.pad-teste {
  padding:400px;
}

.popup-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.popup-content img {
  max-width: 90%;
  max-height: 90%;
  margin: 20px;
}


.grid-cliente-contato {
  margin-top: 15px;
  border-top: 1px solid #f0f0f0;
}

.grupo-form-contato {
  margin-top: 20px;
}

.button-popup {
  margin: 50px 0 15px;
}

.cliente-aviso-popup {
  padding: 1rem !important;
}

.cliente-aviso-container{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.conteudopopupinicial {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  color: #4e4e4e;
  font-weight: 600;
  font-family: "MontSerrat";
}

:deep(.p-dialog .p-dialog-content) {
    padding: 0 1.5rem 2rem 1.5rem !important;
}

:deep(.p-dialog.p-component.p-ripple-disabled.popup-dev) {
  padding: 100rem !important;
  background-color: tomato !important;
}


@media (min-width: 310px) {
.titulo-cliente-desenvolvimento {
  font-size: 20px !important;
}

.buttons-arquivos {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 10px;
  margin: 10px 0;
}

.dados-suframa-inscricao {
  display: flex;
  flex-direction: column;
}
}

@media (min-width: 368px) {
.cep-estado-cidade {
  display: flex;
  flex-direction: column;
}
.cep-estado {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 20px;
}
}

@media (min-width: 450px) {
.dados-suframa-inscricao {
  display: flex;
  flex-direction: row;
  column-gap: 30px;
}
.grupo-dados-cadastrais {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(10, auto);
  grid-column-gap: 20px;
}

.dados-unidade { grid-area: 1 / 1 / 2 / 3; }
.dados-cnpj { grid-area: 2 / 1 / 3 / 2; }
.dados-razao-social { grid-area: 2 / 2 / 3 / 3; }
.dados-nome-fantasia { grid-area: 3 / 1 / 4 / 3; }
.dados-cep { grid-area: 4 / 1 / 5 / 2; }
.dados-estado { grid-area: 4 / 2 / 5 / 3; }
.dados-cidade { grid-area: 5 / 1 / 6 / 2; }
.dados-segmento { grid-area: 5 / 2 / 6 / 3; }
.dados-perfil-material { grid-area: 6 / 1 / 7 / 2; }
.dados-potencial-cliente { grid-area: 6 / 2 / 7 / 3; }
.dados-codigo-cliente { grid-area: 7 / 1 / 8 / 2; }
.dados-curva-cliente { grid-area: 7 / 2 / 8 / 3; }

.dados-suframa-inscricao { grid-area: 8 / 1 / 9 / 3; }
.dados-incentivos { grid-area: 9 / 1 / 10 / 3; }
.buttons-arquivos { grid-area: 10 / 1 / 11 / 3; }


/* .dados-telefone-celular { grid-area: 10 / 7 / 7 / 9; } */



}

@media (min-width: 600px) {
/* .dados-telefone-celular  { grid-area: 8 / 3 / 6 / 5; } */
.cep-estado-cidade {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: auto;
  grid-column-gap: 20px;
}
.cep-estado { grid-area: 1 / 1 / 2 / 3; }
.dados-cidade { grid-area: 1 / 3 / 2 / 5; }

.grupo-dados-cadastrais {
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(9, auto);
}

.dados-unidade { grid-area: 1 / 1 / 2 / 3; }
.dados-cnpj { grid-area: 1 / 3 / 2 / 5; }
.dados-razao-social { grid-area: 2 / 1 / 3 / 3; }
.dados-nome-fantasia { grid-area: 2 / 3 / 3 / 5; }
.dados-cep { grid-area: 3 / 1 / 4 / 2; }
.dados-estado { grid-area: 3 / 2 / 4 / 3; }
.dados-cidade { grid-area: 3 / 3 / 4 / 5; }
.dados-segmento { grid-area: 4 / 1 / 5 / 3; }
.dados-perfil-material { grid-area: 4 / 3 / 5 / 5; }
.dados-potencial-cliente { grid-area: 5 / 1 / 6 / 3; }
.dados-codigo-cliente { grid-area: 5 / 3 / 6 / 5; }
.dados-curva-cliente { grid-area: 6 / 1 / 7 / 3; }
.dados-suframa-inscricao { grid-area: 7 / 1 / 8 / 5; }
.dados-incentivos { grid-area: 8 / 1 / 9 / 5; }
.buttons-arquivos { grid-area: 9 / 1 / 10 / 5; }

.dados-telefone-celular  { grid-area: 7 / 3 / 6 / 5 }

}

@media (min-width: 801px) {
.grupo-dados-cadastrais {
  grid-template-rows: repeat(9, auto);
}

.dados-suframa-inscricao { grid-area: 7 / 1 / 8 / 5; }
.dados-incentivos { grid-area: 8 / 1 / 9 / 5; }
.buttons-arquivos { grid-area: 9 / 1 / 10 / 5; }
}

/* .dados-telefone-celular  { grid-area: 6 / 5 / 4 / 7; } */

@media (min-width: 1025px) {

/* .dados-telefone-celular  { grid-area: 3 / 7 / 4 / 9; } */
.grupo-dados-cadastrais {
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(7, auto);
}

.dados-unidade { grid-area: 1 / 1 / 2 / 3; }
.dados-cnpj { grid-area: 1 / 3 / 2 / 5; }
.dados-razao-social { grid-area: 1 / 5 / 2 / 7; }
.dados-nome-fantasia { grid-area: 2 / 1 / 3 / 3; }
.dados-cep { grid-area: 2 / 3 / 3 / 4; }
.dados-estado { grid-area: 2 / 4 / 3 / 5; }
.dados-cidade { grid-area: 2 / 5 / 3 / 7; }
.dados-segmento { grid-area: 3 / 1 / 4 / 3; }
.dados-perfil-material { grid-area: 3 / 3 / 4 / 5; }
.dados-potencial-cliente { grid-area: 3 / 5 / 4 / 7; }
.dados-codigo-cliente { grid-area: 4 / 1 / 5 / 3; }
.dados-curva-cliente { grid-area: 4 / 3 / 5 / 5; }
.dados-telefone-celular  { grid-area: 4 / 5 / 5 / 7 }

.dados-suframa-inscricao { grid-area: 5 / 1 / 6 / 7; }
.dados-incentivos { grid-area: 6 / 1 / 7 / 7; }
.buttons-arquivos { grid-area: 7 / 1 / 8 / 7; }

.dados-suframa-inscricao {
  column-gap: 15px;
}

.grupo-form-contato {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(6, auto);
  grid-column-gap: 20px;
}

.popup-tipo-contato { grid-area: 1 / 1 / 2 / 2; }
.popup-nome-contato { grid-area: 1 / 2 / 2 / 3; }
.popup-funcao-contato { grid-area: 2 / 1 / 3 / 2; }
.linha1 { grid-area: 3 / 1 / 4 / 3; }
.popup-site { grid-area: 4 / 1 / 5 / 2; }
.popup-email { grid-area: 4 / 2 / 5 / 3; }
.linha2 { grid-area: 5 / 1 / 6 / 3; }
.popup-telefone { grid-area: 6 / 1 / 7 / 2; }
.popup-celular { grid-area: 6 / 2 / 7 / 3; }
}

@media (min-width: 1281px) {
.grupo-form-contato {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(5, auto);
}

.popup-tipo-contato { grid-area: 1 / 1 / 2 / 2; }
.popup-nome-contato { grid-area: 1 / 2 / 2 / 3; }
.popup-funcao-contato { grid-area: 1 / 3 / 2 / 4; }
.linha1 { grid-area: 2 / 1 / 3 / 4; }
.popup-site { grid-area: 3 / 1 / 4 / 2; }
.popup-email { grid-area: 3 / 2 / 4 / 3; }
.linha2 { grid-area: 4 / 1 / 5 / 4; }
.popup-telefone { grid-area: 5 / 1 / 6 / 2; }
.popup-celular { grid-area: 5 / 2 / 6 / 3; }


.grupo-dados-cadastrais {
  grid-template-rows: repeat(6, auto);
}
.dados-suframa-inscricao {
  grid-area: 5 / 5 / 5 / 7;
  z-index: 1;
  column-gap: 30px;
}
.dados-incentivos { grid-area: 5 / 1 / 6 / 7; }
.buttons-arquivos { grid-area: 6 / 1 / 7 / 7; }
}

@media (min-width: 1800px) {
.grupo-dados-cadastrais {
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: repeat(5, auto);
}

.dados-unidade { grid-area: 1 / 1 / 2 / 3; }
.dados-cnpj { grid-area: 1 / 3 / 2 / 5; }
.dados-razao-social { grid-area: 1 / 5 / 2 / 7; }
.dados-nome-fantasia { grid-area: 1 / 7 / 2 / 9; }
.dados-cep { grid-area: 2 / 1 / 3 / 2; }
.dados-estado { grid-area: 2 / 2 / 3 / 3; }
.dados-cidade { grid-area: 2 / 3 / 3 / 5; }
.dados-segmento { grid-area: 2 / 5 / 3 / 7; }
.dados-perfil-material { grid-area: 2 / 7 / 3 / 9; }
.dados-potencial-cliente { grid-area: 3 / 1 / 4 / 3; }
.dados-codigo-cliente { grid-area: 3 / 3 / 4 / 5; }
.dados-curva-cliente { grid-area: 3 / 5 / 4 / 7; }
.dados-suframa-inscricao { grid-area: 3 / 7 / 4 / 9; }
.dados-incentivos { grid-area: 4 / 1 / 5 / 9; }
.buttons-arquivos { grid-area: 5 / 1 / 6 / 9; }

.dados-telefone-celular  { grid-area: 3 / 7 / 9 / 9 }

}
</style>

